<template>
    <div>
        <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>顾问招募</el-breadcrumb-item>
            <el-breadcrumb-item>图片上传</el-breadcrumb-item>
        </el-breadcrumb>

    </div>
</template>

<script>
    export default {
        name: 'pic',
        data() {
            return {

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ht_pic.vue